import * as React from 'react';
import classNames from 'classnames';
import { IAdFoxBannerContext } from '@cian/adfox/build/react';

import styles from './MoreParametersPikBanner.css';

export interface IMoreParametersPickBannerProps {
  context: IAdFoxBannerContext;
  isRedesign: boolean;
}

export function MoreParametersPikBanner(props: IMoreParametersPickBannerProps) {
  return (
    <a
      href={props.context.reference}
      target="_blank"
      className={classNames(styles['link'], props.isRedesign && styles['link_redesign'])}
    >
      <img src={props.context.imageURL} />
    </a>
  );
}
